import * as React  from 'react';
// import * as moment from 'moment'
const moment = require('moment');
import { getDateFormatIndex,getDatePatternArray } from '../../containers/WorkkardDetail/utils';

export default class GetDate extends React.PureComponent{
    constructor(props) {
        super(props);
        this.getMonth = this.getMonth.bind(this);
        this.getYear = this.getYear.bind(this);
    }

    getMonth(month) {
        if(month){
            switch (month.trim()) {
                case '01':
                case '1': 
                    return 'Jan'
    
                case '02':
                case '2':
                    return 'Feb'
                case '03':
                case '3':
                    return 'Mar'
                case '04':
                case '4':
                    return 'Apr'
                case '05': 
                case '5': 
                    return 'May'
                case '06': 
                case '6':
                    return 'Jun'
                case '07': 
                case '7':
                    return 'Jul'
                case '08':
                case '8':
                    return 'Aug'
                case '09': 
                case '9':
                    return 'Sept'
                case '10': return 'Oct'
                case '11': return 'Nov'
                case '12': return 'Dec'
                default: return 'default'
            }
        }        
    }
    getYear(year){
        if (moment().year() == year)
            return ""
        else
            return ', ' + year        
    }
    render(){
        const {inputDate} = this.props;
        const date = getDatePatternArray(inputDate.key);
        const dateIndex = getDateFormatIndex();
        return(
            <span>{this.getMonth(date?.[dateIndex.month])} {date?.[dateIndex.day]}{this.getYear(date?.[dateIndex.year])}</span>
        )
    }
}